import CryptoJS from 'crypto-js';

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    process.env.NEXT_PUBLIC_ENCRYPTION_SECRET
  ).toString();
};

export const decryptData = (data) => {
  try {
    const bytes = CryptoJS.AES.decrypt(
      data,
      process.env.NEXT_PUBLIC_ENCRYPTION_SECRET
    );
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    
    // If decryption results in empty string, data is corrupted
    if (!decrypted) {
      console.warn('Decryption failed: Empty result. localStorage data may be corrupted.');
      return null;
    }
    
    return JSON.parse(decrypted);
  } catch (error) {
    console.error('Decryption error (localStorage data corrupted):', error);
    // Clear corrupted localStorage to prevent future errors
    if (typeof window !== 'undefined') {
      console.warn('Clearing corrupted localStorage data...');
    }
    return null;
  }
};
